import { SquareSplitHorizontalIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Grid = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <SquareSplitHorizontalIcon size={Sizes[size]} {...rest} color={fill} />;
};

Grid.displayName = 'Grid';
